// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"DuoRedirectView__actionButton","loadingIconContainer":"DuoRedirectView__loadingIconContainer","textContainer":"DuoRedirectView__textContainer"};